export const SITE = {
  name: "GoNomikai",
  tagline: "Stay. Sip. Socialize.",
  location: "Mintogang, Gangtok, Sikkim",
  locationShort: "10 mins from MG Marg",
  whatsapp: "919933444505",
  instagram: "https://instagram.com/gonomikai",
  mapUrl:
    "https://www.google.com/maps?q=Gonomikai+Gangtok&output=embed",
};

export const buildWhatsappURL = ({
  intent = "",
  roomType = "",
  checkIn = "",
  checkOut = "",
  guests = 1,
  name = "",
  message = "",
} = {}) => {
  const lines = [
    `Hey GoNomikai! I'd love to book a stay.`,
    name ? `Name: ${name}` : "",
    roomType ? `Room: ${roomType}` : "",
    checkIn ? `Check-in: ${checkIn}` : "",
    checkOut ? `Check-out: ${checkOut}` : "",
    guests ? `Guests: ${guests}` : "",
    intent ? `Vibe: ${intent}` : "",
    message ? `Note: ${message}` : "",
  ].filter(Boolean);
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${SITE.whatsapp}?text=${text}`;
};

export const INTENTS = [
  { id: "meet_people", label: "Meet people", hint: "Show dorms first", emoji: "🤝" },
  { id: "scenic", label: "Scenic & relaxing", hint: "Balcony rooms", emoji: "🏔️" },
  { id: "private", label: "Private & premium", hint: "Terrace rooms", emoji: "✨" },
];

export const FOOD_MENU = [
  {
    title: "Jhol Momo",
    type: "Steamed · Chef's Pick",
    price: 349,
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_gonomikai-launch/artifacts/ypycusa4_Jhol%20Momo.webp",
  },
  {
    title: "Laphing",
    type: "Cold Chili Roll",
    price: 249,
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_gonomikai-launch/artifacts/tqnnuq2v_Laphing.webp",
  },
  {
    title: "Wai Wai Sadeko",
    type: "Street Bite",
    price: 199,
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_gonomikai-launch/artifacts/tmn4d3wx_Wai%20Wai%20Sadeko.webp",
  },
  {
    title: "Butter Tea (Po Cha)",
    type: "Warm Sip",
    price: 149,
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_gonomikai-launch/artifacts/4nl5gnhi_Po%20cha.png",
  },
  {
    title: "Tongba",
    type: "Millet Brew",
    price: 399,
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_gonomikai-launch/artifacts/dautg45g_Tongba.png",
  },
  {
    title: "Chhaang Sour",
    type: "Signature Cocktail",
    price: 449,
    image:
      "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=900&q=80",
  },
];

export const UGC_IMAGES = [
  "https://images.unsplash.com/photo-1596326270763-87f26e0f9225?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwYm9uZmlyZSUyMG5pZ2h0fGVufDB8fHx8MTc3OTQ0Mzc5MXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1530023367847-a683933f4172?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1535025183041-0991a977e25b?auto=format&fit=crop&w=900&q=80",
  "https://images.pexels.com/photos/10433242/pexels-photo-10433242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1503899036084-c55cdd92da26?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=900&q=80",
  "https://images.unsplash.com/photo-1542319630-6bf0d4be0d70?auto=format&fit=crop&w=900&q=80",
];

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_gonomikai-launch/artifacts/qfnmb59x_WhatsApp%20Image%202026-05-20%20at%2017.26.06.jpeg";

export const BAR_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/dbff57c9-f9e4-4cb0-afc8-a88b10f01d55/images/e570d303b6bf7a8ec2feb3bb08f4f266d457a922e27e4ea6b3ff1a12aced062f.png";

// Backwards-compatible alias (deprecated)
export const JAPANESE_BAR_IMAGE = BAR_IMAGE;

export const BONFIRE_IMAGE =
  "https://images.unsplash.com/photo-1596326270763-87f26e0f9225?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwYm9uZmlyZSUyMG5pZ2h0fGVufDB8fHx8MTc3OTQ0Mzc5MXww&ixlib=rb-4.1.0&q=85";

export const DRINKING_GAMES_IMAGE =
  "https://images.pexels.com/photos/10433242/pexels-photo-10433242.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const ROOFTOP_IMAGE =
  "https://images.unsplash.com/photo-1530023367847-a683933f4172?auto=format&fit=crop&w=1200&q=80";

export const MOUNTAIN_IMAGE =
  "https://images.unsplash.com/photo-1672740461276-7dc89382da34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxnYW5ndG9rJTIwbW91bnRhaW5zJTIwc3Vuc2V0fGVufDB8fHx8MTc3OTQ0Mzc5MXww&ixlib=rb-4.1.0&q=85";
